import { useQuery } from "@tanstack/react-query";
import { getUserStatistics } from "src/api/user/statistics";
import { QUERYKEYS } from "src/types/queryKeys";

export const useGetUserStatistics = () => {
  const { isLoading, isError, data, isSuccess, refetch } = useQuery({
    queryKey: [QUERYKEYS.USER_STATISTICS],
    queryFn: () => getUserStatistics(),
    staleTime: 0,
  });

  return {
    isSuccess,
    data,
    isError,
    isLoading,
    refetchStatistics: refetch,
  };
};
